import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id")
      || searchParams.get("session_id");

    if (!sessionId) {
      setError("Missing session_id");
      return;
    }

    api.post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        toast.success(`Welcome, ${r.data.name}`);
        // Clear hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate(r.data.role === "admin" ? "/admin" : "/portal", { replace: true });
      })
      .catch((e) => {
        // eslint-disable-next-line no-console -- surface OAuth failures during debugging
        console.error("Google session exchange failed", e);
        setError(e?.response?.data?.detail || "Authentication failed");
      });
    // Intentionally one-shot on mount: hasProcessed ref guards against re-runs,
    // and `api` is a module-level singleton.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-callback">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-[color:var(--fire-red)] font-medium">{error}</p>
            <button onClick={() => navigate("/login")} className="mt-3 underline">Back to login</button>
          </>
        ) : (
          <p className="text-[color:var(--text-secondary)]">Completing sign-in…</p>
        )}
      </div>
    </div>
  );
}
